import { mapActions, mapGetters, mapState } from 'vuex';
import StepBlock from '@/components/StepBlock.vue';

export default {
  props: {
    valid$: Boolean,
    initialized$: Boolean,
    loading$: Boolean,
    stepNumber: String,
  },
  methods: {
    ...mapActions({
      updateFormField: 'configurator/updateFormField',
    }),
  },
  computed: {
    ...mapState({
      form: state => state.configurator.form,
      files: state => state.configurator.files,
    }),
    ...mapGetters({
      isItemChecked: 'configurator/isItemChecked',
      getStepNumber: 'configurator/getStepNumber',
    }),
  },
  components: {
    StepBlock,
  },
};
